import InboundJourneySearchDate from './InboundJourneySearchDate';

export default InboundJourneySearchDate;
